
































import { Component, Vue, Ref, Prop } from "vue-property-decorator";
import dayjs from 'dayjs';
import moment from 'moment'
import { MaterialCallConfirmDTO, MaterialCallServiceProxy } from '@/service-proxies/app-v2/coproduction.service-proxies';

const mcsp = new MaterialCallServiceProxy()

const columns = [
  {
    title: 'page_material_check_no',
    dataIndex: 'materialCode',
    scopedSlots: { customRender: 'materialCode' },
    ellipsis: true,
    width: 150
  },
  {
    title: 'page_material_check_name',
    dataIndex: 'materialName',
    scopedSlots: { customRender: 'materialName' },
    ellipsis: true,
    width: 150
  },
  {
    title: 'page_plan_shortage_quantity',
    dataIndex: 'number',
    scopedSlots: { customRender: 'number' },
    ellipsis: true,
    width: 150
  },
  {
    title: 'page_plan_station_coding',
    dataIndex: 'workStationCode',
    scopedSlots: { customRender: 'workStationCode' },
    ellipsis: true,
    width: 150
  },
  {
    title: 'page_workstation_maintain_station_name',
    dataIndex: 'workStationName',
    ellipsis: true,
    scopedSlots: { customRender: 'workStationName' },
    width: 150
  },
  {
    title: 'actions',
    dataIndex: 'id',
    ellipsis: true,
    scopedSlots: { customRender: 'id' },
    width: 150
  }
]
export default Vue.extend({
  data(){
    return {
    }
  },
  props:{
    visible:{
      type: Boolean,
      default: false
    },
    dataSource:{
      type: Array,
      default: () => ([])
    },
    plan:{
      type: Object,
      default: () => ({})
    },
    loading:{
      type: Boolean,
      default: false
    }
  },
  computed: {
    columns() {
      return columns.map((item) => {
        return {
          ...item,
          title: this.$t(item.title)
        }
      })
    },
  },
  methods:{
    close(){
      this.$emit('close')
    },
    handleChange(value){
      const data: any = {
        id: value.id,
        materialCode: value.materialCode,
        planId: this.plan.id
      }
      mcsp.confirm(data).then(res =>{
        this.$message.success(this.$t('page_resource_pool_success'))
        this.$emit('confirm')
      })
    }
  }
})
